import { common } from "@/model/common";
import Header from "@/components/Header";
import Banner from "@/components/Banner";
import mixinConfig from "@/mixin/config";

export default {
  name: "no-password",
  components: [Header, Banner],
  mixins: [mixinConfig],
  methods: {
    routerLogin() {
      common.routerPush(this, "increase");
    },
  },
};
